type ThemeConfig = {
  appName: string;
};

const themeConfig: ThemeConfig = {
  appName: "MyTeam",
};

export default themeConfig;
